import React from 'react';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, ClockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const offer = {
  title: 'CRICKET READY™ — COMPLETE PACKAGE',
  description: '1 Main Volume + 5 Strategic Bonuses',
  originalPrice: '$90',
  price: '27',
  currency: '$'
};
const includes = ['1 Complete Volume', '5 Strategic Bonuses', '50+ Training Sessions', '60+ Professional Drills', 'Lifetime Access'];
const ctaText = '🚀 I WANT CRICKET READY NOW';
const ctaHref = 'https://cricket-ready.impultienda.ar/checkout';
const savings = 'SAVE $63';
const trustBadges = [{
  icon: LockIcon,
  label: 'Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Card · GooglePay · ApplePay'
}];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-[#FAFAFA] py-16 sm:py-24 px-4" data-id="element-137">
      <div className="max-w-xl mx-auto" data-id="element-138">
        <div className="text-center mb-10" data-id="element-139">
          <span className="inline-block bg-[#0A0A0A]/10 text-[#0A0A0A] text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest mb-4" data-id="element-140">
            Limited-Time Offer
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] mb-3 tracking-tight" data-id="element-141">
            Everything included,{' '}
            <span className="text-[#d4af37]" data-id="element-142">one single price.</span>
          </h2>
          <p className="text-[#5A5A66] text-sm sm:text-base font-bold" data-id="element-143">
            Complete package. No upsells. No surprises.
          </p>
        </div>

        <div className="relative bg-white border border-[#E5E5EA] rounded-3xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)] overflow-hidden mb-6" data-id="element-144">
          {/* Top accent bar */}
          <div className="h-1.5 w-full bg-[#0A0A0A]" data-id="element-145" />

          {/* Dark header */}
          <div className="bg-[#0A0A0A] px-6 sm:px-10 py-6 text-center" data-id="element-146">
            <h3 className="text-white font-black text-lg sm:text-2xl tracking-tight" data-id="element-147">
              🏆 {offer.title}
            </h3>
            <p className="text-[#d4af37] text-sm sm:text-base font-semibold mt-1.5" data-id="element-148">
              {offer.description}
            </p>
          </div>

          <div className="px-6 sm:px-10 pt-8 pb-8 sm:pb-10 text-center" data-id="element-149">
            {/* Price block */}
            <div className="mb-7 pb-7 border-b border-[#E5E5EA]" data-id="element-150">
              <div className="text-[#5A5A66] text-sm font-bold mb-2" data-id="element-151">
                Total value:{' '}
                <span className="line-through" data-id="element-152">{offer.originalPrice}</span>
              </div>
              <div className="flex items-start justify-center gap-1" data-id="element-153">
                <span className="font-black text-3xl sm:text-4xl text-[#0A0A0A] mt-2 sm:mt-3" data-id="element-154">
                  {offer.currency}
                </span>
                <span className="font-black text-7xl sm:text-8xl text-[#0A0A0A] tracking-tighter leading-none" data-id="element-155">
                  {offer.price}
                </span>
                <span className="self-end mb-2 sm:mb-3 ml-1 text-[#5A5A66] text-sm font-bold" data-id="element-156">
                  one-time
                </span>
              </div>
              <div className="flex items-center justify-center gap-3 mt-4" data-id="element-157">
                <span className="inline-block bg-[#d4af37] text-[#0A0A0A] text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest shadow-sm" data-id="element-158">
                  {savings}
                </span>
                <span className="text-[#5A5A66] text-xs font-bold uppercase tracking-wider" data-id="element-159">
                  Lifetime access
                </span>
              </div>
            </div>

            {/* Includes */}
            <p className="text-[#0A0A0A] text-xs font-black uppercase tracking-widest mb-5" data-id="element-160">
              What's included
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 max-w-md mx-auto text-left mb-8" data-id="element-161">
              {includes.map(item => <div key={item} className="flex items-center gap-2.5" data-id="element-162">
                  <span className="flex items-center justify-center w-5 h-5 rounded-full bg-[#d4af37]/15 flex-shrink-0" data-id="element-163">
                    <CheckIcon className="w-3.5 h-3.5 text-[#d4af37]" strokeWidth={3} data-id="element-164" />
                  </span>
                  <span className="text-[#0A0A0A] text-sm font-semibold" data-id="element-165">
                    {item}
                  </span>
                </div>)}
            </div>

            {/* Countdown */}
            <div className="flex items-center justify-center gap-3 mb-6 bg-[#FAFAFA] py-3 px-4 rounded-xl border border-[#E5E5EA]" data-id="element-166">
              <span className="flex items-center gap-1.5 text-[#0A0A0A] text-xs sm:text-sm font-black uppercase tracking-wider" data-id="element-167">
                <ClockIcon className="w-4 h-4 text-[#0A0A0A]" data-id="element-168" />
                Ends in
              </span>
              <CountdownTimer size="sm" blinking={false} data-id="element-169" />
            </div>

            {/* CTA */}
            <a href={ctaHref} className="btn-cta-green block w-full text-center font-black text-base sm:text-xl py-5 rounded-2xl transition-colors shadow-lg mb-4 !bg-[#22c55e] !text-white" data-id="element-170">
              {ctaText}
            </a>

            <p className="flex items-center justify-center gap-1.5 text-[#5A5A66] text-xs font-semibold mb-6" data-id="element-171">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-[#d4af37]" data-id="element-172" />
              Backed by our 7-day money-back guarantee
            </p>

            {/* Trust badges */}
            <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 pt-6 border-t border-[#E5E5EA]" data-id="element-173">
              {trustBadges.map(({
              icon: Icon,
              label
            }) => <span key={label} className="flex items-center gap-1.5 text-[#5A5A66] text-xs sm:text-sm font-bold" data-id="element-174">
                  <Icon className="w-4 h-4 text-[#0A0A0A]" data-id="element-175" />
                  {label}
                </span>)}
            </div>
          </div>
        </div>

        <p className="text-[#5A5A66] text-xs text-center font-semibold" data-id="element-176">
          💱 You'll be charged in your local currency
        </p>
      </div>
    </section>;
}